import React from 'react';
import TabDetails from '../components/TabDetails';
import VerticalTabs from '../../_common/components/VerticalTabs';
import TabDocuments from '../components/TabDocumnets';
import OldInspectionStatus from '../components/OldInspectionStatus';
import {StreetsProvider} from '../../_common/components/CitiesAndStreets';
import {OldInspectionDetailsProvider} from '../components/OldInspectionsDetailsContext';
import {OldInspectionDocumentsProvider} from '../components/OldInspectionsDocumentsContext';
import {OldInspectionStatusProvider} from '../components/OldInspectionStatusContext';

const OldInspectionDetails = () => {
  return (
    <div className={'pt-8'}>
      <StreetsProvider>
        <OldInspectionDetailsProvider>
          <OldInspectionDocumentsProvider>
            <VerticalTabs
              headerContent={
                <OldInspectionStatusProvider>
                  <OldInspectionStatus/>
                </OldInspectionStatusProvider>
              }
              tabs={[
                {
                  id: 'inspection',
                  label: 'דוחות',
                  content: <TabDetails/>,
                  icon: '/media/common/Clipboard.svg',
                },
                {
                  id: 'documents',
                  label: 'מסמכים',
                  content: <TabDocuments/>,
                  icon: '/media/common/File-plus.svg',
                },
              ]}
            />
          </OldInspectionDocumentsProvider>
        </OldInspectionDetailsProvider>
      </StreetsProvider>
    </div>
  );
};

export default OldInspectionDetails;